import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from "../../store";
import type React from "react";


interface Props {
    allowedRoles?: string[];
}

const ProtectedRoute: React.FC<Props> = ({
    allowedRoles
}) => {
    const { user, activeRole } = useSelector((state: RootState) => state.auth);


    // Check if user is authenticated
    if (!user) {
        return <Navigate to="/login" replace />
    }

    // If allowedRoles specified, check authorization
    if (allowedRoles && allowedRoles.length > 0) {
        // Admin main_role has access to all pages
        const isMainAdmin = user.main_role === "Admin";

        // First check if activeRole matches (fast path)
        const activeRoleAllowed = allowedRoles.includes(activeRole ?? "");

        // Also check if user has any of the allowed roles in their roles array
        // This handles the race condition during profile switching where activeRole
        // may not have updated yet in the component's view of Redux state
        const userHasAllowedRole = user.roles?.some(role => allowedRoles.includes(role));

        // Check if user's main_role matches any allowed role
        const mainRoleAllowed = user.main_role ? allowedRoles.includes(user.main_role) : false;

        if (!isMainAdmin && !activeRoleAllowed && !userHasAllowedRole && !mainRoleAllowed) {
            return <Navigate to={`/${activeRole?.toLowerCase() ?? ""}`} replace />;
        }
    }

    // Authorized
    return <Outlet />;
}
 
export default ProtectedRoute;